import { render, staticRenderFns } from "./CallToAction.vue?vue&type=template&id=43f97bd6&scoped=true&"
import script from "./CallToAction.vue?vue&type=script&lang=ts&"
export * from "./CallToAction.vue?vue&type=script&lang=ts&"
import style0 from "./CallToAction.vue?vue&type=style&index=0&id=43f97bd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f97bd6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AnLink: require('/home/circleci/app/components/storyblok/AnLink.vue').default})
